import Contracts from '@/components/settings/contracts/Contracts';
import ContractsForm from '@/components/settings/contracts/ContractsForm';
import CostCenter from '@/components/settings/costCenter/CostCenter';
import CostCenterForm from '@/components/settings/costCenter/CostCenterForm';
import Providers from '@/components/settings/providers/Providers';
import ProvidersForm from '@/components/settings/providers/ProvidersForm';
import Settings from '@/components/settings/Settings';

export default {
    path: '/settings',
    component: Settings,
    children: [
        {
            path: '/costcenter',
            name: 'CostCenter',
            component: CostCenter,
        },
        {
            path: '/costcenter/new',
            name: 'NewCostCenter',
            component: CostCenterForm,
        },
        {
            path: '/costcenter/edit/:costCenterId',
            name: 'EditCostCenter',
            component: CostCenterForm,
        },
        {
            path: '/contracts',
            name: 'Contracts',
            component: Contracts,
        },
        {
            path: '/contracts/new',
            name: 'NewContractType',
            component: ContractsForm
        },
        {
            path: '/contracts/edit/:contractTypeId',
            name: 'EditContractType',
            component: ContractsForm,
        },
        {
            path: '/providers',
            name: 'Providers',
            component: Providers,
        },
        {
            path: '/providers/new',
            name: 'NewProvider',
            component: ProvidersForm
        },
        {
            path: '/providers/edit/:providerId',
            name: 'EditProvider',
            component: ProvidersForm
        },
    ],
    meta: {requiresAuth: true}
}